/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  withStyles,
  createStyles,
} from "@material-ui/core";
import { formatCurrency } from "@roc/ui/utils";
import { observer } from "mobx-react";

const StyledTableCell = withStyles(() =>
  createStyles({
    body: {
      fontSize: "0.9rem",
      padding: 10,
      border: "1px solid black",
    },
    head: {
      backgroundColor: "#f0f0f0",
      fontWeight: "bold",
      border: "1px solid black",
      textAlign: "center",
      fontSize: "0.7rem",
      padding: 10,
      letterSpacing: "1px"
    },
  })
)(TableCell);

interface TitleHistoryTableProps {
  propertyTitleActivities: any[]
}

export const TitleHistoryTable = observer(({ propertyTitleActivities }: TitleHistoryTableProps) => {

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell>ACTION DATE</StyledTableCell>
            <StyledTableCell>PURCHASE DATE</StyledTableCell>
            <StyledTableCell>SELL DATE</StyledTableCell>
            <StyledTableCell>RECORDING DATE</StyledTableCell>
            <StyledTableCell>DESCRIPTION</StyledTableCell>
            <StyledTableCell>SELLER</StyledTableCell>
            <StyledTableCell>BUYER</StyledTableCell>
            <StyledTableCell>LENDER</StyledTableCell>
            <StyledTableCell>PRICE</StyledTableCell>
            <StyledTableCell>LOAN AMOUNT</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(!propertyTitleActivities || propertyTitleActivities.length === 0) ? (
            <TableRow>
              <StyledTableCell colSpan={10} align="center">
                No records available
              </StyledTableCell>
            </TableRow>
          ) : (propertyTitleActivities.map((row, index) => (
            <TableRow key={index}>
              <StyledTableCell>{row.actionDate}</StyledTableCell>
              <StyledTableCell>{row.purchaseDate}</StyledTableCell>
              <StyledTableCell>{row.sellDate}</StyledTableCell>
              <StyledTableCell>{row.recordingdate}</StyledTableCell>
              <StyledTableCell align="center">{row.description}</StyledTableCell>
              <StyledTableCell align="center">{row.seller}</StyledTableCell>
              <StyledTableCell align="center">{row.buyer}</StyledTableCell>
              <StyledTableCell align="center">{row.lender}</StyledTableCell>
              <StyledTableCell align="right">{formatCurrency(row.sellPrice, 0)}</StyledTableCell>
              <StyledTableCell align="right">{formatCurrency(row.loanAmount, 0)}</StyledTableCell>
            </TableRow>)))
          }
        </TableBody>
      </Table>
    </TableContainer>
  );
});
